export const truncateLabelToWidth = (value, maxWidth, measureText) => {
  if (measureText(value) <= maxWidth) {
    return value;
  }

  let truncated = value;
  while (truncated.length > 0) {
    const label = `${truncated.trimEnd()}...`;
    if (measureText(label) <= maxWidth) {
      return label;
    }
    truncated = truncated.slice(0, -1);
  }

  return '...';
};

export const splitCandidateLabelLines = (value, maxWidth, measureText, maxLines = 2) => {
  const words = `${value || ''}`.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) {
    return [''];
  }

  const lines = [];
  let line = '';
  let wordIndex = 0;

  while (wordIndex < words.length) {
    const nextLine = line ? `${line} ${words[wordIndex]}` : words[wordIndex];
    if (measureText(nextLine) > maxWidth) {
      if (!line) {
        line = truncateLabelToWidth(words[wordIndex], maxWidth, measureText);
        wordIndex += 1;
        continue;
      }

      lines.push(line);
      if (lines.length === maxLines - 1) {
        return [...lines, truncateLabelToWidth(words.slice(wordIndex).join(' '), maxWidth, measureText)];
      }
      line = '';
      continue;
    }
    line = nextLine;
    wordIndex += 1;
  }

  return line ? [...lines, line] : lines;
};
